import debounce from 'lodash.debounce';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    SearchOverlayContainer as SourceSearchOverlayContainer
} from 'SourceComponent/SearchOverlay/SearchOverlay.container';
import SearchBarReducer from 'Store/SearchBar/SearchBar.reducer';
import { SearchResultsType } from 'Type/Search.type';
import { withReducers } from 'Util/DynamicReducer';

import { SEARCH_TIMEOUT } from './SearchOverlay.config';

/** @namespace PeggysagePwa/Component/SearchOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    searchResults: state.SearchBarReducer.result
});

/** @namespace PeggysagePwa/Component/SearchOverlay/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // ...
});

/** @namespace PeggysagePwa/Component/SearchOverlay/Container */
export class SearchOverlayContainer extends SourceSearchOverlayContainer {
    static propTypes = {
        ...SourceSearchOverlayContainer.propTypes,
        searchResults: SearchResultsType.isRequired
    };

    containerFunctions = {
        ...this.containerFunctions,
        onTabClick: this.onTabClick.bind(this)
    };

    state = {
        activeTab: null,
        isActiveTabManuallySet: false
    };

    debouncedMakeRequest = debounce(this.makeSearchRequest, SEARCH_TIMEOUT);

    componentDidMount() {
        this.setActiveTab();
    }

    componentDidUpdate(prevProps) {
        const {
            searchCriteria,
            searchResults,
            clearSearchResults
        } = this.props;
        const {
            searchCriteria: prevSearchCriteria,
            searchResults: prevSearchResults
        } = prevProps;

        if (searchCriteria !== prevSearchCriteria) {
            clearSearchResults();
            this.debouncedMakeRequest();
        }

        if (searchResults !== prevSearchResults) {
            this.setActiveTab();
        }

        // @TODO listen to clicks on results ? (to close overlay on mobile) instead of change of pathname in Header
        // @TODO (problem when we do not change page... like on FAQ)
    }

    componentWillUnmount() {
        this.debouncedMakeRequest.cancel();
        this.setState({ isActiveTabManuallySet: false });
    }

    /**
     * Override
     * @returns {{activeTab: null}}
     */
    containerProps() {
        const { activeTab } = this.state;

        return {
            ...super.containerProps(),
            activeTab
        };
    }

    /**
     * @param {string|null} type
     */
    setActiveTab(type = null) {
        const { searchResults } = this.props;
        const { isActiveTabManuallySet } = this.state;

        // Manually defined by clicking on tab
        if (type) {
            this.setState({ activeTab: type });

            return;
        }

        // If active tab had been manually changed and tab still exists
        if (isActiveTabManuallySet && searchResults.find((res) => res.type === type && res.items.length)) {
            return;
        }

        // Called after results update => take first tab with results
        const types = searchResults.filter((searchResult) => !!searchResult.total_count)
            .map((searchResult) => searchResult.type);

        const activeTab = types[0];

        this.setState({
            activeTab,
            isActiveTabManuallySet: false
        });
    }

    /**
     * Override: change arguments for search query
     */
    makeSearchRequest() {
        const {
            makeSearchRequest,
            clearSearchResults,
            searchCriteria
        } = this.props;

        if (searchCriteria) {
            clearSearchResults();
            const search = encodeURIComponent(searchCriteria.trim().replace(/%/g, '%25'));

            makeSearchRequest({
                args: {
                    search,
                    pageSize: 5,
                    currentPage: 1
                }
            });
        }
    }

    /**
     *
     * @param {SearchResultType} searchResult
     * @param {MouseEvent} _e
     */
    onTabClick(searchResult, _e) {
        const { type } = searchResult;

        this.setState({ isActiveTabManuallySet: true }, () => this.setActiveTab(type));
    }
}

export default withReducers({
    SearchBarReducer
})(connect(mapStateToProps, mapDispatchToProps)(SearchOverlayContainer));
